import { render } from "./Perfil.vue?vue&type=template&id=acf7cfba&scoped=true"
import script from "./Perfil.vue?vue&type=script&lang=js"
export * from "./Perfil.vue?vue&type=script&lang=js"

import "./Perfil.vue?vue&type=style&index=0&id=acf7cfba&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-acf7cfba"]])

export default __exports__